import { ConfigClass } from '../../../utils/config';
export const config = new ConfigClass();
